import { DotLottie } from "@lottiefiles/dotlottie-web";

class LottieDecoration extends HTMLElement {
  connectedCallback() {
    this.canvas = this.querySelector("canvas");
    const json = this.querySelector(
      'script[type="application/json"]',
    ).textContent.trim();

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.observer.disconnect();
          setTimeout(() => this.init(json), 350);
        });
      },
      { threshold: 0.1 },
    );

    this.observer.observe(this);
  }

  init(json) {
    const blob = new Blob([json], { type: "application/json" });
    const src = URL.createObjectURL(blob);

    const dotLottie = new DotLottie({
      canvas: this.canvas,
      src,
      autoplay: true,
      loop: false,
      renderConfig: { autoResize: true },
    });

    dotLottie.addEventListener("load", () => {
      URL.revokeObjectURL(src);
      const { width, height } = dotLottie.animationSize();
      if (width && height) {
        this.canvas.style.aspectRatio = `${width} / ${height}`;
      }
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get("lottie-decoration")) {
  customElements.define("lottie-decoration", LottieDecoration);
}
